/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedStatements, getAllowedOutputs } from '../block_compatibility_checks';
import { dataset, getCurrentSat, validateFrom, validateTo } from '../dataset';
import { AreaService } from '@/services/area.service';
import { CustomFieldDate } from '../../blocklyFieldDate';
import { areaChange } from '../helper_functions';

// --------------------------------------------------------------------------------------------------

/*
* Select from-to and area block
*/

Blockly.Blocks['input_date_area_selection'] = {
    init: function () {
        let fd = dataset.setFrom(getCurrentSat(this))
        if (fd == null) { fd = '2018-01-01' }
        let td = dataset.getTo(getCurrentSat(this))
        if (td == null) { td = '2019-01-01' }
        var areas = AreaService.getAreas();
        this.appendDummyInput('inp')
            .appendField("From:    ", 'from_text')
            .appendField(new CustomFieldDate(fd,
                function (newValue) { return validateFrom(this, newValue); }, 'true'), 'fd')
            .appendField(' To:', 'to_text')
            .appendField(new CustomFieldDate(td,
                function (newValue) { return validateTo(this, newValue); }, 'true'), 'td');
        this.appendDummyInput('area_input')
            .appendField("Area: ")
            .appendField(new Blockly.FieldDropdown(areas), "area");
        this.appendStatementInput("do")
            .setCheck(getAllowedStatements('optical_area_time'));
        this.setInputsInline(false);
        this.setPreviousStatement(true, 'optical_area_time');
        this.setNextStatement(true, getAllowedOutputs('optical_area_time'));
        this.setStyle('input');
        this.setTooltip(Blockly.Msg.DATE_AREA_BLOCK_TOOLTIP);
        this.setHelpUrl("");
        this.setOnChange(() => {

            if (this.getFieldValue('area') !== this.previous_area) {
                if (this.getFieldValue('area') == 'upload_shp') {
                    this.updateAreaParams_('add');
                } else if (this.previous_area == 'upload_shp') {
                    this.updateAreaParams_('remove');
                }
                this.previous_area = this.getFieldValue('area');
            }

            if (this.prev_sat != getCurrentSat(this)) {
                this.updateDates_(getCurrentSat(this));
                this.prev_sat = getCurrentSat(this);
            }
        });

        this.areaSubscription = AreaService.areaChange$.subscribe( () => {
            let result = areaChange(this, "area_input", "area");
            if(!result) {
                this.areaSubscription.unsubscribe();
            }
        });
    },

    updateDates_: function (sat) {
        let input = this.getInput('inp')
        input.removeField('from_text', true);
        input.removeField('fd', true);
        input.removeField('to_text', true);
        input.removeField('td', true);
        input.removeField('td_yearly', true);
        input.removeField('fd_yearly', true);

        if (sat == 'PALSAR') {
            this.getInput('inp')
                .appendField("Year:  ", "from_text")
                .appendField(new Blockly.FieldDropdown([["2007", "2007"], ["2008", "2008"], ["2009", "2009"], ["2010", "2010"], ["2015", "2015"], ["2016", "2016"], ["2017", "2017"]]), 'fd_yearly')
                .appendField("  To:  ", "to_text")
                .appendField(new Blockly.FieldDropdown([["2007", "2007"], ["2008", "2008"], ["2009", "2009"], ["2010", "2010"], ["2015", "2015"], ["2016", "2016"], ["2017", "2017"]]), 'td_yearly');
            var dropd = this.getField('fd_yearly');
            dropd.setValue('2008');
        } else {
            let fd = dataset.setFrom(getCurrentSat(this))
            if (fd == null) { fd = '2018-01-01' }
            let td = dataset.getTo(getCurrentSat(this))
            if (td == null) { td = '2019-01-01' }
            this.getInput('inp')
                .appendField("From:    ", 'from_text')
                .appendField(new CustomFieldDate(fd,
                    function (newValue) { return validateFrom(this, newValue); }, 'true'), 'fd')
                .appendField(' To:', 'to_text')
                .appendField(new CustomFieldDate(td,
                    function (newValue) { return validateTo(this, newValue); }, 'true'), 'td');
            /*// DATE CHECK
            .appendField(new Blockly.FieldDate(dataset.getFrom(sat), function (newValue) {
                var before = new Date(newValue);
                var fromStr = dataset.getFrom(sat);
                var fromDate = new Date(fromStr);
                if (before < fromDate)
                  return fromStr;
                return newValue;
              }), 'fd')
        .appendField(' To:', 'to_text')
        .appendField(new Blockly.FieldDate(this.addOneYear(this.getFieldValue('fd')), function (newValue) {
          var before = new Date(this.sourceBlock_.getFieldValue('fd'));
          var after = new Date(newValue);
          var td = new Date(dataset.getTo(sat));
          if ((after - before > 31622400000) || (after - before <= 0) || (after > td)) {
                  
                  $ function() {
                    $("#dialog").dialog('open');
                  };
                  return this.sourceBlock_.prev_date;
                }}
          this.sourceBlock_.prev_date = newValue;
          return newValue;
        }), 'td');*/
        }
    },

    updateAreaParams_: function (param) {
        if (param == 'add') {
            this.getInput('area_input').appendField(" Path: ", "path_text")
                .appendField(new Blockly.FieldTextInput("user/shp_name"), "path");
        } else {
            let input = this.getInput('area_input');
            input.removeField("path_text", true);
            input.removeField("path", true);
        }
    },

    addOneYear: function (fd) {
        var d = new Date(fd);
        var c = new Date(d.getFullYear() + 1, d.getMonth(), d.getDate());
        c = c.toISOString().split('T')[0];
        this.prev_date = c;
        return c;
    }
};